import { withNamespaces } from '@/i18n/route-namespaces'

export const settingsRoutes = {
  path: 'settings',
  lazy: withNamespaces(['workspaces'], async () => {
    const { default: CompanySettingsPage } = await import(
      '@/pages/company/settings'
    )

    return { Component: CompanySettingsPage }
  }),
}
